export function translateRole(role) {
    switch (role) {
        case 'admin':
            return 'Administrador';
        case 'owner':
            return 'Proprietário';
        case 'manager':
            return 'Gerente';
        case 'coordinator':
            return 'Coordenador';
        case 'prospector':
            return 'Prospector';
        case 'customer_success':
            return 'CS';
        default:
            return 'Desconhecido';
    }
}
export function translateAccountType(type) {
    switch (type) {
        case 'free':
            return 'Grátis';
        case 'active':
            return 'Pagante';
        case 'waiting':
            return 'Aguardando pagamento';
        case 'migrated':
            return 'Migrado';
        case 'suspended':
            return 'Suspenso';
        case 'inactive':
            return 'Inativo';
        default:
            return 'Desconhecido';
    }
}
export function companyFields(company) {
    return {
        'id da empresa': company.company_id,
        'cnpj da empresa': company.nu_cnpj,
        'nome da empresa': company.company_name,
        'nome fantasia da empresa': company.fantasy_name,
        'capital social da empresa': company.social_capital,
        'situação de empresa': company.status,
        'cnae primário': company.cnae && company.cnae.primary,
        'cnae secundário': company.cnae && company.cnae.secondary,
        'faturamento por empresa': company.revenue && company.revenue.company,
        'faturamento por cnpj': company.revenue && company.revenue.cnpj,
        setor: company.area,
        website: company.website,
        'data de criação da empresa': company.founded_at,
        endereço: company.address &&
            `
${company.address.type_public_place} 
${company.address.name_public_place} - 
${company.address.number_public_place} - 
${company.address.neighborhood} - 
${company.address.city} - 
${company.address.state} - 
${company.address.cep}
`.replace(/\n/g, ''),
    };
}
export function decisorFields(decisor) {
    return decisor
        ? {
            'nome do decisor': decisor.name,
            'nível do decisor': decisor.level,
            'resumo do decisor': decisor.summary,
            'linkedin do decisor': decisor.linkedin,
            'email do decisor': decisor.email,
            'cargo do decisor': decisor.position,
            'departamento do decisor': decisor.department,
        }
        : {};
}
